import { SDKInitConfig, SDKInitParams } from "../models/sdk";

export function getConfig(): SDKInitConfig {
    return {
        reconnectionTimeout: 120,
        idleTimeout: 900,
        idleShutdownGraceTimeout: 120,
        logLevel: 'DEBUG'
    };
}

export function getParams(url_base:string, jwt: string, integrationId: string): SDKInitParams {
    return {
        hostURL: url_base,
        integrationId: integrationId,
        token: jwt,
        sessionParameters: {
            'model' : 'ABC-123'
        }
    };
}
